import {MenuResponse} from "./menu-response";

export class MenuListResponse {
    menuList: MenuResponse[] = [];
}
